function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.334 2.809v-.667A.333.333 0 0011 1.809H8v-.667a.667.667 0 00-.666-.667H4.667A.667.667 0 004 1.142v.667H1a.333.333 0 00-.333.333v.667c0 .184.15.333.333.333h10c.184 0 .334-.15.334-.333zm-8.087 11a1.333 1.333 0 01-1.333-1.24l-.58-8.094h9.333L10.1 12.57a1.334 1.334 0 01-1.333 1.24h-5.52z"
});

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgTrash;